import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getSalesContractDetail,
  // getPagedContracts,
  // addOwnContracts,
  // getContractsStandartRates,
  // getOldContractsRates,
  // getContractsToPartner,
  // addReferralLinkDetailsForLanguage,
  // getOwnContractReview,
} from "./thunk";

export const initialState = {
  // getPagedContracts
  getSalesContractDetailData: {},
  getSalesContractDetailError: {},
  isSalesContractDetailListSuccess: false,
  // // getPagedContracts
  // getPagedContractsData: [],
  // getPagedContractsError: {},
  // isListSuccess: false,
  // // getOwnContractReview
  // getOwnContractReviewData: [],
  // getOwnContractReviewError: {},
  // isListOwnContractReviewSuccess: false,
  // // getContractsStandartRates
  // getContractsStandartRatesData: [],
  // getContractsStandartRatesError: {},
  // isListStandartRatesSuccess: false,
  // // getOldContractsRates
  // getOldContractsRatesData: [],
  // getOldContractsRatesError: {},
  // isListOldContractsRatesSuccess: false,
  // // getContractsToPartner
  // getContractsToPartnerData: [],
  // getContractsToPartnerError: {},
  // isListContractsToPartnerSuccess: false,
  // // addReferralLinkDetailsForLanguage
  // addReferralLinkDetailsForLanguageData: [],
  // addReferralLinkDetailsForLanguageError: {},
  // isReferralLinkDetailsForLanguageSuccess: false,
};

const ContractsSlice = createSlice({
  name: "ContractsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getSalesContractDetail
    builder.addCase(
      getSalesContractDetail.fulfilled,
      (state: any, action: any) => {
        state.getSalesContractDetailData = action.payload;
        state.isSalesContractDetailListSuccess = true;
      }
    );
    builder.addCase(
      getSalesContractDetail.rejected,
      (state: any, action: any) => {
        state.getSalesContractDetailError = action.payload || null;
      }
    );
    // // getPagedContracts
    // builder.addCase(getPagedContracts.fulfilled, (state: any, action: any) => {
    //   state.getPagedContractsData = action.payload;
    //   state.isListSuccess = true;
    // });
    // builder.addCase(getPagedContracts.rejected, (state: any, action: any) => {
    //   state.getPagedContractsError = action.payload || null;
    // });
    // // getOwnContractReview
    // builder.addCase(
    //   getOwnContractReview.fulfilled,
    //   (state: any, action: any) => {
    //     state.getOwnContractReviewData = action.payload;
    //     state.isListOwnContractReviewSuccess = true;
    //   },
    // );
    // builder.addCase(
    //   getOwnContractReview.rejected,
    //   (state: any, action: any) => {
    //     state.getOwnContractReviewError = action.payload || null;
    //   },
    // );
    // // getContractsStandartRates
    // builder.addCase(
    //   getContractsStandartRates.fulfilled,
    //   (state: any, action: any) => {
    //     state.getContractsStandartRatesData = action.payload;
    //     state.isListStandartRatesSuccess = true;
    //   },
    // );
    // builder.addCase(
    //   getContractsStandartRates.rejected,
    //   (state: any, action: any) => {
    //     state.getContractsStandartRatesError = action.payload.error || null;
    //   },
    // );
    // // getOldContractsRates
    // builder.addCase(
    //   getOldContractsRates.fulfilled,
    //   (state: any, action: any) => {
    //     state.getOldContractsRatesData = action.payload;
    //     state.isListOldContractsRatesSuccess = true;
    //   },
    // );
    // builder.addCase(
    //   getOldContractsRates.rejected,
    //   (state: any, action: any) => {
    //     state.getOldContractsRatesError = action.payload.error || null;
    //   },
    // );
    // // getContractsToPartner
    // builder.addCase(
    //   getContractsToPartner.fulfilled,
    //   (state: any, action: any) => {
    //     state.getContractsToPartnerData = action.payload;
    //     state.isListContractsToPartnerSuccess = true;
    //   },
    // );
    // builder.addCase(
    //   getContractsToPartner.rejected,
    //   (state: any, action: any) => {
    //     state.getContractsToPartnerError = action.payload || null;
    //   },
    // );
    // // addReferralLinkDetailsForLanguage
    // builder.addCase(
    //   addReferralLinkDetailsForLanguage.fulfilled,
    //   (state: any, action: any) => {
    //     state.addReferralLinkDetailsForLanguageData = action.payload;
    //     state.isReferralLinkDetailsForLanguageSuccess = true;
    //   },
    // );
    // builder.addCase(
    //   addReferralLinkDetailsForLanguage.rejected,
    //   (state: any, action: any) => {
    //     state.addReferralLinkDetailsForLanguageError = action.payload || null;
    //   },
    // );
  },
});

export default ContractsSlice.reducer;
